import React from 'react';

// 1. Import all the exercise components
import ReadingPart1 from './exercises/ReadingPart1.js';
import ReadingPart2 from './exercises/ReadingPart2.js';
import ReadingPart3 from './exercises/ReadingPart3.js';
import ReadingPart4 from './exercises/ReadingPart4.js';
import ReadingPart5 from './exercises/ReadingPart5.js';
import ReadingPart6 from './exercises/ReadingPart6.js';
import ReadingPart7 from './exercises/ReadingPart7.js';
import ListenPart1 from './exercises/ListenPart1.js';
import ListenPart2 from './exercises/ListenPart2.js';
import ListenPart3 from './exercises/ListenPart3.js';
import ListenPart4 from './exercises/ListenPart4.js';
import ListenPart5 from './exercises/ListenPart5.js';
import ExerciseHeader from './common/ExerciseHeader.js';

// 2. Create the component map
const exerciseComponentMap = {
  'reading_writing_flyer_part_1': ReadingPart1,
  'reading_writing_flyer_part_2': ReadingPart2,
  'reading_writing_flyer_part_3': ReadingPart3,
  'reading_writing_flyer_part_4': ReadingPart4,
  'reading_writing_flyer_part_5': ReadingPart5,
  'reading_writing_flyer_part_6': ReadingPart6,
  'reading_writing_flyer_part_7': ReadingPart7,
  'listen_flyer_part_1': ListenPart1,
  'listen_flyer_part_2': ListenPart2,
  'listen_flyer_part_3': ListenPart3,
  'listen_flyer_part_4': ListenPart4,
  'listen_flyer_part_5': ListenPart5,
};

const ExerciseView = ({ exercise, attemptId, showHint, isReviewMode }) => {
  if (!exercise) {
    return <p>Loading exercise...</p>;
  }

  const ExerciseComponent = exerciseComponentMap[exercise.type];

  if (!ExerciseComponent) {
    return (
      <div>
        <div className="error-message">Error: Unsupported exercise type "{exercise.type}"</div>
        <pre>{JSON.stringify(exercise, null, 2)}</pre>
      </div>
    );
  }

  const { part_label, question_count_label, instruction, story_text, audio_url } = exercise.content_data;

  return (
    <div className="exercise-view">
      <ExerciseHeader
        part_label={part_label}
        question_count_label={question_count_label}
        instruction={instruction}
        story_text={story_text}
        audio_url={audio_url}
        ASSET_BASE_URL={process.env.REACT_APP_ASSET_URL}
      />
      <ExerciseComponent
        key={exercise.id}
        attemptId={attemptId}
        exerciseId={exercise.id}
        exerciseData={exercise}
        showHint={showHint}
        isReviewMode={isReviewMode}
      />
    </div>
  );
};

export default ExerciseView;
